<div *ngIf="!!curationItemId" class="curation-match">
  <div class="curation-match-background"></div>
  <span class="curation-match-text">{{curationType}} {{curationItemId}}</span>
</div>
